import QuineHwo from './img/QuineHwo.jpg';
import cokepotato from './img/cokepotato.jpg'
import FallowFoot from './img/FallowFoot_y.jpg'
import Falstarin from './img/Falstarin.jpg'
import ghospirit from './img/ghospirit_y.jpg'
import inthemultiverse from './img/inthemultiverse_y.jpg'
import Lincadi from './img/Lincadi_y.jpg'
import LunarGem15 from './img/lunargem15_y.jpg'
import OkayDerp_1 from './img/OkayDerp_1_y.jpg'
import OkayDerp_2 from './img/OkayDerp_2_y.jpg'
import ShaunaJade from './img/ShaunaJade_y.jpg'
import shookbanana from './img/shookbanana.jpg'
import wraithdoge from './img/wraithdoge_y.jpg'
import zecori from './img/zecoritheweirdone_y.jpg'

export const STATS = {
    youtubeSubCount: 62,
    twitchFollowcount: 2.6
}

export const COLORS = {
    'youtube': 'ff0000',
    'youtube-etc': 'ff0000',
    'twitch': 'cc00cc',
    'discord': '6666ff',
    'twitter': '33ccff',
    'tiktok': '444444',
    'merch': 'ff6700',
    'bluesky': '0099ff',
    'patreon': '222222'
}

export const SIZES = {
    FONT_SIZE_MAIN: 32,
    FONT_SIZE_SECONDARY: 20,
    FONT_SIZE_TERTIARY: 20,
    ICON_SIZE_MAIN: 80,
    ICON_SIZE_SECONDARY: 50,
    ICON_SIZE_SECONDARY_MOBILE: 35
}

export const ANIMATION_TYPES = {
    MAIN: 'animate__tada',
    SECONDARY: 'animate__pulse'
}

export const FAN_ART_IMAGES = [
    {
        srcPath: Lincadi,
        altText: 'LeonSBU Fan Art, by Lincadi',
        id: 1,
    },
    {
        srcPath: inthemultiverse,
        altText: 'LeonSBU Fan Art, by in-the-multiverse',
        id: 2,
    },
    {
        srcPath: ShaunaJade,
        altText: 'LeonSBU Fan Art, by ShaunaJade',
        id: 3,
    },
    {
        srcPath: FallowFoot,
        altText: 'LeonSBU Fan Art, by FallowFoot',
        id: 4,
    },
    {
        srcPath: wraithdoge,
        altText: 'LeonSBU Fan Art, by wraithdoge',
        id: 5,
    },
    {
        srcPath: cokepotato,
        altText: 'LeonSBU Fan Art, by cokepotato',
        id: 6,
    },
    {
        srcPath: zecori,
        altText: 'LeonSBU Fan Art, by zecoritheweirdone',
        id: 7,
    },
    {
        srcPath: QuineHwo,
        altText: 'LeonSBU Fan Art, by Quine Hwo',
        id: 8,
    },
    {
        srcPath: ghospirit,
        altText: 'LeonSBU Fan Art, by ghospirit',
        id: 9,
    },
    {
        srcPath: OkayDerp_1,
        altText: 'LeonSBU Fan Art, by OkayDerp',
        id: 10,
    },
    {
        srcPath: shookbanana,
        altText: 'LeonSBU Fan Art, by shookbanana',
        id: 11,
    },
    {
        srcPath: Falstarin,
        altText: 'LeonSBU Fan Art, by Falstarin',
        id: 12,
    },
    {
        srcPath: OkayDerp_2,
        altText: 'LeonSBU Fan Art, by OkayDerp',
        id: 13,
    },
    {
        srcPath: LunarGem15,
        altText: 'LeonSBU Fan Art, by LunarGem15',
        id: 14,
    },
];

export const FAN_ARTIST_USERNAMES = [
    'Lincadi',
    'in-the-multiverse',
    'ShaunaJade',
    'Fallow Foot',
    'wraithdoge',
    'cokepotato',
    'zecoritheweirdone',
    'Quine Hwo',
    'ghospirit',
    'OkayDerp',
    'shookbanana',
    'Falstarin',
    'LunarGem15'
]